module.exports = "<div \tid=\"wrapper\"\n\t\t\t[ngStyle]=\"wrapperStyle\">\n\t<img \tid=\"image\"\n\t\t\t\t[ngClass]=\"imageClass\"\n\t\t\t\t[src]=\"config.image\"/>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/electraLib/component/splash/splash.component.html
// module id = 436
// module chunks = 1